import {
  ApiResponse,
  CashDiscountGrouped,
  CreateDiscount,
  TokenData,
  CashDiscount,
  OtpResponse,
  CreateDiscountLimits,
  CombinedDiscountTypeLimit,
  CombinedDiscount,
  CreateCombinedDiscountLimits,
} from '../models';
import * as http from './http';
import ApiService from './service';

export class CombinedDiscountService extends ApiService {
  public async loadCombinedDiscountType() {
    const url = `${this.apiDomain}/api/discount/combined`;

    const resposne = await http.get<ApiResponse<CashDiscountGrouped>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async createDiscount(data: CreateDiscount) {
    const url = `${this.apiDomain}/api/discount/combined`;

    const response = await http.post<ApiResponse<CombinedDiscount>>(
      url,
      data,
      this.store
    );
    return response?.data;
  }

  public async updateDiscount(id: string, data: CreateDiscount) {
    const url = `${this.apiDomain}/api/discount/combined/${id}`;

    const response = await http.put<ApiResponse<CombinedDiscount>>(
      url,
      data,
      this.store
    );
    return response?.data;
  }

  public async getCashDiscount(id: string) {
    const url = `${this.apiDomain}/api/discount/combined/${id}`;

    const response = await http.get<ApiResponse<CombinedDiscount>>(
      url,
      this.store
    );
    return response?.data?.data;
  }

  public async updateCashDiscountTypes(
    data?: CombinedDiscountTypeLimit,
    id?: string
  ) {
    const url = `${this.apiDomain}/api/discount/combined/${id}/discount-types`;

    const response = await http.put<ApiResponse<CombinedDiscount>>(
      url,
      data,
      this.store
    );
    return response?.data?.data;
  }

  public async removeDiscountLimit(discountId: string, id: string) {
    const url = `${this.apiDomain}/api/discount/combined/${discountId}/limits/${id}`;

    const response = await http.remove<ApiResponse<CombinedDiscount>>(
      url,
      this.store
    );
    return response?.data?.data;
  }

  public async requestOtp(purpose?: string) {
    const url = `${this.apiDomain}/api/otp/request`;

    const response = await http.post<ApiResponse<OtpResponse>>(
      url,
      {
        purpose: purpose || 'Confirm Discount Request',
      },
      this.store
    );
    return response.data;
  }

  public async reSendOtp(id?: string, purpose?: string) {
    const url = `${this.apiDomain}/api/otp/${id}/resend`;

    const response = await http.put<ApiResponse<OtpResponse>>(
      url,
      {
        purpose: purpose || 'Confirm Discount Request',
      },
      this.store
    );
    return response.data;
  }
  public async updateCashDiscountLimits(
    data?: CreateCombinedDiscountLimits,
    id?: string
  ) {
    const url = `${this.apiDomain}/api/discount/combined/${id}/limits`;

    const response = await http.put<ApiResponse<OtpResponse>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
}
